import axios from "../../../util/payrightAxios";
import { CustomerStatementVM } from "./CustomerStatementVM";
import { Metadata } from "./Metadata";

type FetchStatementsResult = {
  success: true;
  statements: CustomerStatementVM[];
  metadata: Metadata;
} | {
  success: false;
};

export const fetchStatements = async (page: number, limit: number): Promise<FetchStatementsResult> => {
  try {
    const customerId = localStorage.getItem("customerId");
    const authToken = localStorage.getItem("authToken");

    axios.defaults.headers.common["auth-token"] = authToken;

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/customer/${customerId}/statements?page=${page}&limit=${limit}`,
    );

    return {
      success: true,
      statements: response.data.data.statements,
      metadata: response.data.data.metadata,
    };
  } catch (e) {
    console.log("Error fetching statements", e);
  }

  return {
    success: false,
  };
};
